export const company = {
  brand: "SC Dijital",
  founderFirst: "Şükrü",
  founderLast: "Çağlar",
  founder: "Şükrü Çağlar",
  city: "Kayseri, Türkiye",
  phone: "+90 505 101 45 85",
  phoneTel: "+905051014585",
  email: "info@scdijital.com",
  emails: ["info@scdijital.com", "sukru.caglar@scdijital.com"],
  whatsapp: "https://wa.me/905051014585",
  logo: "https://res.cloudinary.com/dzfjzjhm8/image/upload/v1777727483/ChatGPT_Image_2_May_2026_16_08_10_d7iexn.png",
};

export function whatsappHref(text) {
  const encoded = encodeURIComponent(text || "");
  return encoded
    ? `${company.whatsapp}?text=${encoded}`
    : company.whatsapp;
}
